import ptBR from "../i18n/pt-BR.json";
import enUS from "../i18n/en-US.json";
import esES from "../i18n/es-ES.json";

import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "app-registrar",
    templateUrl: "./registrar.component.html",
    styleUrls: ["./registrar.component.scss"]
})
export class RegistrarComponent implements OnInit {
    constructor(private translate: TranslateService) {}
    ngOnInit(): void {
        this.translate.setTranslation("pt-BR", ptBR, true);
        this.translate.setTranslation("en-US", enUS, true);
        this.translate.setTranslation("es-ES", esES, true);
    }
}
